module.exports = __webpack_public_path__ + "img/gallery04.889e1835.png";